var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-home" },
    _vm._l(_vm.settings, function(setting, indexSetting) {
      return _c(
        "div",
        { key: indexSetting, staticClass: "settings-home__block" },
        [
          _c(
            "div",
            { staticClass: "settings-home__block-title" },
            [
              _c("CompassColoredIcon", {
                attrs: { icon: setting.icon, color: "brand" }
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "typographies-heading-h3" }, [
                _vm._v(_vm._s(setting.label))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "settings-home__block-list" },
            _vm._l(setting.sub, function(sub, indexSub) {
              return _c(
                "li",
                {
                  key: indexSub,
                  staticClass: "settings-home__block-list-item"
                },
                [
                  sub.vueRouting
                    ? _c(
                        "router-link",
                        {
                          staticClass: "typographies-paragraph-medium-semibold",
                          attrs: { to: sub.url }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(sub.label) +
                              "\n                "
                          )
                        ]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "typographies-paragraph-medium-semibold",
                          attrs: { href: sub.url }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(sub.label) +
                              "\n                "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  sub.flag
                    ? _c("CompassFlag", {
                        staticClass: "settings-home__flag",
                        attrs: {
                          label: sub.flag.label,
                          size: sub.flag.size,
                          beta: sub.flag.beta
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }